'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _resource = require('../resource');

var _resource2 = _interopRequireDefault(_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Subscriptions = function (_Resource) {
    (0, _inherits3.default)(Subscriptions, _Resource);

    function Subscriptions() {
        (0, _classCallCheck3.default)(this, Subscriptions);
        return (0, _possibleConstructorReturn3.default)(this, (Subscriptions.__proto__ || (0, _getPrototypeOf2.default)(Subscriptions)).apply(this, arguments));
    }

    (0, _createClass3.default)(Subscriptions, [{
        key: 'delete',

        /**
         * @api {delete} /v1/organization_subscriptions/:organization_subscription_id delete
         * @apiGroup Subscriptions
         * @apiName delete
         * @apiDescription Delete the organizationSubscription. This is a hard delete.
         * @apiParam {Number} organization_subscription_id
         * @apiExample {js} Example:
         *             gigwalk.subscriptions.delete({...})
         */
        value: function _delete(params) {
            return this.client.delete('/v1/organization_subscriptions/' + params.organization_subscription_id);
        }

        /**
         * @api {get} /v1/organization_subscriptions/:organization_subscription_id get
         * @apiGroup Subscriptions
         * @apiName get
         * @apiDescription If specified, return information about the organizationSubscription. Otherwise, list all organizationSubscriptions of the organization.
                           Defaults to the current user's organization if no organizationID is specified.
         * @apiParam {Number} organization_subscription_id
         * @apiExample {js} Example:
         *             gigwalk.subscriptions.get({...})
         */

    }, {
        key: 'get',
        value: function get(params) {
            return this.client.get('/v1/organization_subscriptions/' + params.organization_subscription_id);
        }

        /**
         * @api {get} /v1/organizations/:organization_id/subscriptions getAll
         * @apiGroup Subscriptions
         * @apiName getAll
         * @apiDescription Get list of subscriptions based on paginaion, sort parameters and project state
         * @apiParam {Number} organization_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.subscriptions.getAll({...})
         */

    }, {
        key: 'getAll',
        value: function getAll(params) {
            var query = params ? this.stringForQueryObject(params.query) : '';
            return this.client.get('/v1/organizations/' + params.organization_id + '/subscriptions?' + query);
        }

        /**
         * @api {post} /v1/organization_subscriptions/:organization_subscription_id clone
         * @apiGroup Subscriptions
         * @apiName clone
         * @apiDescription Create a new subscription by cloning the given organizationSubscription or schedule autoassignment for the subscription.
         * @apiParam {Number} organization_subscription_id
         * @apiParam {String} [action='clone']
         * @apiExample {js} Example:
         *             gigwalk.subscriptions.clone({...})
         */

    }, {
        key: 'clone',
        value: function clone(params) {
            var data = {
                action: params.action ? params.action : 'clone'
            };

            return this.client.post('/v1/organization_subscriptions/' + params.organization_subscription_id, data);
        }

        /**
         * @api {put} /v1/organization_subscriptions/:organization_subscription_id update
         * @apiGroup Subscriptions
         * @apiName update
         * @apiDescription Update organizationSubscription.
         * @apiParam {Number} organization_subscription_id
         * @apiParam {Number} version_id
         * @apiParam {Object} subscription
         * @apiExample {js} Example:
         *             gigwalk.subscriptions.update({...})
         */

    }, {
        key: 'update',
        value: function update(params) {
            return this.client.put('/v1/organization_subscriptions/' + params.organization_subscription_id, (0, _extends3.default)({}, params.subscription));
        }

        /**
         * @api {post} /v1/organizations/:organization_id/subscriptions bulkCreate
         * @apiGroup Subscriptions
         * @apiName bulkCreate
         * @apiDescription Create new organizationSubscription(s). Maximum of five new subscriptions.
         * @apiParam {Number} organization_id
         * @apiParam {Object[]} subscriptions
         * @apiExample {js} Example:
         *             gigwalk.subscriptions.bulkCreate({...})
         */

    }, {
        key: 'bulkCreate',
        value: function bulkCreate(params) {
            var data = {
                projects: params.subscriptions
            };

            return this.client.post('/v1/organizations/' + params.organization_id + '/subscriptions', data);
        }

        /**
         * @api {post} /v1/organizations/:organization_id/subscriptions/search searchWithParams
         * @apiGroup Subscriptions
         * @apiName searchWithParams
         * @apiDescription Search organizationSubscriptions. searchParameters should be in key op value (e.g. date_created > now; title = 'project_name').
         * @apiParam {Number} organization_id
         * @apiParam {String} query_string
         * @apiExample {js} Example:
         *             gigwalk.subscriptions.searchWithParams({...})
         */

    }, {
        key: 'searchWithParams',
        value: function searchWithParams(params) {
            var data = {
                query_string: params.query_string
            };

            return this.client.post('/v1/organizations/' + params.organization_id + '/subscriptions/search', data);
        }

        /**
         * @api {delete} /v1/organizations/:organization_id/subscriptions/:organization_subscription_id deleteForOrganization
         * @apiGroup Subscriptions
         * @apiName deleteForOrganization
         * @apiDescription Delete the specified project. Only DRAFT projects may be deleted.
         * @apiParam {Number} organization_id
         * @apiParam {Number} organization_subscription_id
         * @apiExample {js} Example:
         *             gigwalk.subscriptions.deleteForOrganization({...})
         */

    }, {
        key: 'deleteForOrganization',
        value: function deleteForOrganization(params) {
            return this.client.delete('/v1/organizations/' + params.organization_id + '/subscriptions/' + params.organization_subscription_id);
        }

        /**
         * @api {put} /v1/organizations/:organization_id/subscriptions/:organization_subscription_id updateForOrganization
         * @apiGroup Subscriptions
         * @apiName updateForOrganization
         * @apiDescription Modify project.
         * @apiParam {Number} organization_id
         * @apiParam {Number} organization_subscription_id
         * @apiParam {Number} version_id
         * @apiParam {Object} subscription
         * @apiExample {js} Example:
         *             gigwalk.subscriptions.updateForOrganization({...})
         */

    }, {
        key: 'updateForOrganization',
        value: function updateForOrganization(params) {
            return this.client.put('/v1/organizations/' + params.organization_id + '/subscriptions/' + params.organization_subscription_id, (0, _extends3.default)({}, params.subscription));
        }

        /**
         * @api {post} /v2/organizations/:organization_id/search/subscriptions/filters searchWithField
         * @apiGroup Subscriptions
         * @apiName searchWithField
         * @apiDescription Searches ES documents using searchField.
         * @apiParam {Number} organization_id
         * @apiParam {String} search_field
         * @apiParam {String} query_string
         * @apiExample {js} Example:
         *             gigwalk.subscriptions.searchWithField({...})
         */

    }, {
        key: 'searchWithField',
        value: function searchWithField(params) {
            var data = {
                search_field: params.search_field,
                query_string: params.query_string
            };

            return this.client.post('/v2/organizations/' + params.organization_id + '/search/subscriptions/filters', data);
        }

        /**
         * @api {post} /v2/organizations/:organization_id/search/subscriptions search
         * @apiGroup Subscriptions
         * @apiName search
         * @apiDescription Searches all strings in ES documents.
         * @apiParam {Number} organization_id
         * @apiParam {String} query_string
         * @apiExample {js} Example:
         *             gigwalk.subscriptions.search({...})
         */

    }, {
        key: 'search',
        value: function search(params) {
            var data = {
                query_string: params.query_string
            };

            return this.client.post('/v2/organizations/' + params.organization_id + '/search/subscriptions', data);
        }
    }]);
    return Subscriptions;
}(_resource2.default);

exports.default = Subscriptions;
//# sourceMappingURL=index.js.map